// src/components/auth/PasswordField.tsx
import React, { useState } from "react";
import { IoEye, IoEyeOff, IoLockClosedOutline } from "react-icons/io5";

export default function PasswordField(props: {
  label: string;
  id: string;
  value: string;
  onChange: (v: string) => void;
  translate?: (k: string) => string;
  disabled?: boolean;
}) {
  const { label, id, value, onChange, disabled = false } = props;
  const [show, setShow] = useState(false);

  return (
    <div className="col-lg-6">
      <div className="mb-1">
        <label className="form-label" htmlFor={id}>
          {label}
        </label>

        <div className="input-group input-group-merge form-password-toggle">
          <span className="input-group-text bg-white">
            <IoLockClosedOutline style={{ color: "#6b7280", fontSize: "18px" }} />
          </span>
          <input
            className="form-control form-control-merge"
            id={id}
            type={show ? "text" : "password"}
            name={id}
            autoComplete="new-password"
            placeholder="············"
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
          />

          <span
            className="input-group-text cursor-pointer"
            onClick={() => !disabled && setShow(!show)}
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          >
            {show ? <IoEyeOff /> : <IoEye />}
          </span>
        </div>
      </div>
    </div>
  );
}
